import { Box, Button, Card, Flex, Typography, theme } from '@fe-toolkit/web-components/ssr'

type ExitFeesOfferCardProps = {
  isCreatingEvidenceSession?: boolean
  onUploadExitBillClick?: () => void
}

export function ExitFeesOfferCard({ isCreatingEvidenceSession, onUploadExitBillClick }: ExitFeesOfferCardProps) {
  return (
    <Card
      alignItems="center"
      backgroundColor="black"
      borderRadius="medium"
      display="flex"
      flexDirection="column"
      padding="small"
      sx={{
        flexShrink: 0,
        minHeight: '312px',
        scrollSnapAlign: 'start',
        width: '240px',
      }}
    >
      <Typography as="p" color="white" sx={{ fontSize: '20px', fontWeight: 'bold' }} textAlign="center">
        Exit fee from your old provider? We’ll give it you back.
      </Typography>
      <Flex alignItems="center" flexDirection="column" justifyContent="center" sx={{ flexGrow: 1, width: '100%' }}>
        <Flex
          alignItems="center"
          justifyContent="center"
          sx={{
            alignSelf: 'center',
            flexShrink: 0,
            width: '92px',
            height: '92px',
            borderRadius: '100%',
            backgroundColor: theme.colors.pink,
            transform: 'rotate(6deg)',
            textAlign: 'center',
            margin: `${theme.spacing.small} auto`,
            [theme.breakpoints.up('medium')]: {
              alignSelf: 'flex-start',
              width: '92px',
              height: '92px',
            },
          }}
        >
          <Box>
            <Typography as="span" color="black" sx={{ display: 'block' }} variant="whisper">
              up to
            </Typography>
            <Typography as="span" color="black" sx={{ display: 'block', fontSize: '20px', fontWeight: 'bold' }}>
              £300
            </Typography>
            <Typography as="span" color="black" sx={{ display: 'block' }} variant="whisper">
              credit
            </Typography>
          </Box>
        </Flex>
      </Flex>
      <Flex flexDirection="column" sx={{ width: '100%' }}>
        <Button
          isSmall
          isDisabled={isCreatingEvidenceSession}
          isLoading={isCreatingEvidenceSession}
          sx={{
            padding: '4px 20px',
          }}
          testId="upload-exit-bill-button"
          onClick={onUploadExitBillClick}
        >
          Upload my exit bill
        </Button>
      </Flex>
    </Card>
  )
}
